<div class="rt-px-15 rt-pt-15">
  <h2 mat-dialog-title> {{entity?.headerMessage}} </h2>
  <mat-dialog-content>
    {{entity?.entityMessage}}
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="rt-mb-10">
    <button mat-raised-button class="rt-mr-5" (click)="onClose()">{{entity.confirmBtnLabel || "Yes"}}</button>
    <button mat-raised-button color="primary" (click)="onCancelled()">No</button>
  </mat-dialog-actions>
</div>